export default "__VITE_PUBLIC_ASSET__cb9e079e__"